export enum EvaluationRelevantInstanceType {
  paragraph = "paragraph",
  token = "token",
}
